export default __webpack_public_path__ + "static/media/developer_logo.747da81a.png";